import { ApiParameters } from './api-parameters';
import { ApiPostRequest } from './api-post-request';

export class AuthorizeRequest extends ApiPostRequest
{
    public constructor(username: string, password: string, webapiBasepath: string)
    {
        super('/player/authorize',
            new ApiParameters(),
            null,
            {
                username,
                password
            },
            webapiBasepath
        );
    }
}
